/** Pattern that matches no real member, used to force "expose zero methods" when nothing is graftable. */
export const NO_GRAFTABLE_METHODS_SENTINEL = '__no_graftable_methods__'

export const WIZARD_COPY = {
  title: 'Configure GG type & method filters',
  description:
    'Select the facade types and callable members to expose through Graftcode Gateway. The type filter is applied first, then the method filter trims members on the surviving types. Leaving a section empty exposes everything discoverable.',
  sections: {
    analyzerComments: 'Analyzer comments',
    types: '1. Types to expose',
    methods: '2. Methods to expose',
    preview: '3. Preview',
    output: '4. Output',
  },
  quickOptions: {
    ariaLabel: 'Graftability shortcuts',
    graftableTypes: {
      label: 'Expose only graftable types (recommended)',
      hintWhenMethodsOnly: 'All types are exposed because "only graftable methods" is enabled.',
      hintDefault: 'Auto-selects the types whose members are all graftable and ignores manual type choices.',
    },
    graftableMethods: {
      label: 'Expose only graftable methods (recommended)',
      hint: 'Marks every type and auto-selects all graftable members, ignoring manual choices.',
    },
  },
  types: {
    typeWarning: 'Contains non-graftable members',
    patternsLabel: 'Advanced type patterns',
    patternsPlaceholder: '*Calculator, MyNamespace.*',
    patternsHelper: 'Comma-separated wildcard patterns (* and ?). Added on top of the checkboxes above.',
  },
  methods: {
    scopeAll: 'Apply to all selected types',
    scopePerType: 'Only on a specific type',
    selectTypeHint: 'Select at least one type above.',
    autoSelectedHint: 'Graftable methods are selected automatically. Review the preview below.',
    emptyHint: 'No callable members available for the current selection.',
    constructorTag: 'constructor',
    nonGraftableTag: 'non-graftable',
    patternsLabel: 'Advanced method patterns',
    patternsPlaceholder: 'add, Get*, BasicCalculator.add',
    patternsHelper: 'Bare name matches that method on every type; Type.method scopes it to one type.',
  },
  preview: {
    typesExposed: 'Types exposed',
    methodsExposed: 'Methods exposed',
    fieldsExposed: 'Fields exposed',
    typeIncludedNoMethods: 'Type included, no methods exposed',
    methodCount: (count: number) => `${count} method${count === 1 ? '' : 's'}`,
  },
  output: {
    copyConfig: 'Copy config',
    copyCommand: 'Copy command',
  },
  actions: {
    close: 'Close',
    done: 'Done',
  },
} as const
